import env from "../../common/env";

export const IDLE_LOGOUT_MESSAGE =
  "Your session has expired due to inactivity.";

export const IDLE_TIMEOUT = env.REACT_APP_IDLE_TIMEOUT || 900000;
export const PROMPT_DURATION = 1 * 60 * 1000;
export const MAX_IDLE_TIMEOUT = 30 * 60 * 1000;
